/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed8b341bea9e633d9bf846cc430b9b60>>
 * @codegenCommand yarn build tokens
 */

type TokenValue =
	| string;

type TokenValueOriginal =
	| string;

type TokenAttributes = {
	group: string;
	state: string;
	introduced: string;
	description: string;
	suggest?: string[];
	deprecated?: string;
};


type Token = {
	value: TokenValue;
	filePath: string;
	isSource: boolean;
	attributes: TokenAttributes;
	original: {
		value: TokenValueOriginal;
		attributes: TokenAttributes;
	};
	name: string;
	path: string[];
	cleanName: string;
};

const tokens: Token[] = [
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "2px"
      ],
      "introduced": "6.1.0",
      "description": "Used for small containers such as badges."
    },
    "value": "2px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "2px"
        ],
        "introduced": "6.1.0",
        "description": "Used for small containers such as badges."
      },
      "value": "Radius02"
    },
    "name": "radius.xsmall",
    "path": [
      "radius",
      "xsmall"
    ],
    "cleanName": "radius.xsmall"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "4px"
      ],
      "introduced": "6.1.0",
      "description": "Used for labels."
    },
    "value": "4px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "4px"
        ],
        "introduced": "6.1.0",
        "description": "Used for labels."
      },
      "value": "Radius04"
    },
    "name": "radius.small",
    "path": [
      "radius",
      "small"
    ],
    "cleanName": "radius.small"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "6px"
      ],
      "introduced": "6.1.0",
      "description": "Used for buttons and inputs."
    },
    "value": "6px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "6px"
        ],
        "introduced": "6.1.0",
        "description": "Used for buttons and inputs."
      },
      "value": "Radius06"
    },
    "name": "radius.medium",
    "path": [
      "radius",
      "medium"
    ],
    "cleanName": "radius.medium"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "8px"
      ],
      "introduced": "6.1.0",
      "description": "Used for cards and small containers."
    },
    "value": "8px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "8px"
        ],
        "introduced": "6.1.0",
        "description": "Used for cards and small containers."
      },
      "value": "Radius08"
    },
    "name": "radius.large",
    "path": [
      "radius",
      "large"
    ],
    "cleanName": "radius.large"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "12px"
      ],
      "introduced": "6.1.0",
      "description": "Used for modals and large containers."
    },
    "value": "12px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "12px"
        ],
        "introduced": "6.1.0",
        "description": "Used for modals and large containers."
      },
      "value": "Radius12"
    },
    "name": "radius.xlarge",
    "path": [
      "radius",
      "xlarge"
    ],
    "cleanName": "radius.xlarge"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "50%"
      ],
      "introduced": "6.1.0",
      "description": "Used for circular containers, like a rounded button."
    },
    "value": "9999px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "50%"
        ],
        "introduced": "6.1.0",
        "description": "Used for circular containers, like a rounded button."
      },
      "value": "Radius99"
    },
    "name": "radius.full",
    "path": [
      "radius",
      "full"
    ],
    "cleanName": "radius.full"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "introduced": "6.2.0",
      "description": "Used for tiles only."
    },
    "value": "25%",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "introduced": "6.2.0",
        "description": "Used for tiles only."
      },
      "value": "RadiusPercentage25"
    },
    "name": "radius.tile",
    "path": [
      "radius",
      "tile"
    ],
    "cleanName": "radius.tile"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.5.2",
      "deprecated": "6.1.0",
      "description": "The default border radius."
    },
    "value": "4px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.5.2",
        "deprecated": "6.1.0",
        "description": "The default border radius."
      },
      "value": "Radius04"
    },
    "name": "border.radius.[default]",
    "path": [
      "border",
      "radius",
      "[default]"
    ],
    "cleanName": "border.radius"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.1.0",
      "deprecated": "6.1.0",
      "description": "Used for selection indicators, like tabs."
    },
    "value": "2px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.1.0",
        "deprecated": "6.1.0",
        "description": "Used for selection indicators, like tabs."
      },
      "value": "Radius02"
    },
    "name": "border.radius.050",
    "path": [
      "border",
      "radius",
      "050"
    ],
    "cleanName": "border.radius.050"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.1.0",
      "deprecated": "6.1.0",
      "description": "Used for buttons and inputs."
    },
    "value": "4px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.1.0",
        "deprecated": "6.1.0",
        "description": "Used for buttons and inputs."
      },
      "value": "Radius04"
    },
    "name": "border.radius.100",
    "path": [
      "border",
      "radius",
      "100"
    ],
    "cleanName": "border.radius.100"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.1.0",
      "deprecated": "6.1.0",
      "description": "Used for smaller cards."
    },
    "value": "8px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.1.0",
        "deprecated": "6.1.0",
        "description": "Used for smaller cards."
      },
      "value": "Radius08"
    },
    "name": "border.radius.200",
    "path": [
      "border",
      "radius",
      "200"
    ],
    "cleanName": "border.radius.200"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.1.0",
      "deprecated": "6.1.0",
      "description": "Used for cards and larger containers."
    },
    "value": "12px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.1.0",
        "deprecated": "6.1.0",
        "description": "Used for cards and larger containers."
      },
      "value": "Radius12"
    },
    "name": "border.radius.300",
    "path": [
      "border",
      "radius",
      "300"
    ],
    "cleanName": "border.radius.300"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.1.0",
      "deprecated": "6.1.0",
      "description": "Used for modals."
    },
    "value": "16px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.1.0",
        "deprecated": "6.1.0",
        "description": "Used for modals."
      },
      "value": "Radius16"
    },
    "name": "border.radius.400",
    "path": [
      "border",
      "radius",
      "400"
    ],
    "cleanName": "border.radius.400"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.1.0",
      "deprecated": "6.1.0",
      "description": "Used for circular containers, like a rounded button."
    },
    "value": "9999px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.1.0",
        "deprecated": "6.1.0",
        "description": "Used for circular containers, like a rounded button."
      },
      "value": "Radius99"
    },
    "name": "border.radius.circle",
    "path": [
      "border",
      "radius",
      "circle"
    ],
    "cleanName": "border.radius.circle"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "1px"
      ],
      "introduced": "1.5.2",
      "description": "The default width for all standard component borders and dividers."
    },
    "value": "1px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "1px"
        ],
        "introduced": "1.5.2",
        "description": "The default width for all standard component borders and dividers."
      },
      "value": "BorderWidth1"
    },
    "name": "border.width.[default]",
    "path": [
      "border",
      "width",
      "[default]"
    ],
    "cleanName": "border.width"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.2.1",
      "deprecated": "6.1.0",
      "description": "Used for zero width borders."
    },
    "value": "0px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.2.1",
        "deprecated": "6.1.0",
        "description": "Used for zero width borders."
      },
      "value": "Size0"
    },
    "name": "border.width.0",
    "path": [
      "border",
      "width",
      "0"
    ],
    "cleanName": "border.width.0"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.5.2",
      "deprecated": "6.1.0",
      "description": "Used for indicators like tab and menu selected states."
    },
    "value": "3px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.5.2",
        "deprecated": "6.1.0",
        "description": "Used for indicators like tab and menu selected states."
      },
      "value": "Size200"
    },
    "name": "border.width.indicator",
    "path": [
      "border",
      "width",
      "indicator"
    ],
    "cleanName": "border.width.indicator"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "deprecated",
      "introduced": "1.5.2",
      "deprecated": "6.1.0",
      "description": "Used for focus, active or selected inputs."
    },
    "value": "2px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "deprecated",
        "introduced": "1.5.2",
        "deprecated": "6.1.0",
        "description": "Used for focus, active or selected inputs."
      },
      "value": "BorderWidth2"
    },
    "name": "border.width.outline",
    "path": [
      "border",
      "width",
      "outline"
    ],
    "cleanName": "border.width.outline"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "2px"
      ],
      "introduced": "6.1.0",
      "description": "The width used to indicate a selected element, such as an active tab or a chosen item."
    },
    "value": "2px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "2px"
        ],
        "introduced": "6.1.0",
        "description": "The width used to indicate a selected element, such as an active tab or a chosen item."
      },
      "value": "BorderWidth2"
    },
    "name": "border.width.selected",
    "path": [
      "border",
      "width",
      "selected"
    ],
    "cleanName": "border.width.selected"
  },
  {
    "attributes": {
      "group": "shape",
      "state": "active",
      "suggest": [
        "2px"
      ],
      "introduced": "6.1.0",
      "description": "The width used for the focus ring on interactive elements."
    },
    "value": "2px",
    "filePath": "schema/themes/atlassian-shape/shape.tsx",
    "isSource": true,
    "original": {
      "attributes": {
        "group": "shape",
        "state": "active",
        "suggest": [
          "2px"
        ],
        "introduced": "6.1.0",
        "description": "The width used for the focus ring on interactive elements."
      },
      "value": "BorderWidth2"
    },
    "name": "border.width.focused",
    "path": [
      "border",
      "width",
      "focused"
    ],
    "cleanName": "border.width.focused"
  }
];

export default tokens;
